import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcpResourcePipe } from './acp-resource.pipe';
import {TrustHtmlPipe} from './trusthtml-pipe'

@NgModule({
  declarations: [
    AcpResourcePipe,
    TrustHtmlPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AcpResourcePipe,
    TrustHtmlPipe
  ]
})
export class PipesModule {
}
